import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import format from 'date-fns/format';
import addMinutes from 'date-fns/add_minutes';
import { Container, TextContainer, Title, TitleETA, SubTitle, Icon } from './styles';
import {
  PICKUP,
  DROPOFF,
  RETURN,
  ORDER_STATE_PENDING_ASSIGNMENT,
  ORDER_STATE_CANCELLED,
} from '../../../../utils/constants';
import { waypointsAheadText } from './utils/waypointsAhead';

const TITLE = {
  pickup: 'Arriving',
  dropoff: 'Arriving',
  return: 'Arriving',
};

const SUBTITLE = {
  pickup: () => 'Your driver is on the way',
  dropoff: venueName => `Your ${venueName} order is on the way`,
  return: () => 'Your driver is on the way',
};

const getSubtitle = (jobState, type, venueName, numberOfWaypointsAhead) => {
  if (numberOfWaypointsAhead > 0 && jobState !== ORDER_STATE_PENDING_ASSIGNMENT) {
    return waypointsAheadText(numberOfWaypointsAhead);
  }

  switch (jobState) {
    case ORDER_STATE_PENDING_ASSIGNMENT:
      return 'Check back soon to track it';
    case ORDER_STATE_CANCELLED:
      return 'Your order has been cancelled';
    default:
      return SUBTITLE[type](venueName);
  }
};

const getTitleNode = (jobState, numberOfWaypointsAhead) => {
  if (jobState === ORDER_STATE_PENDING_ASSIGNMENT) {
    return 'Your order is being processed';
  }

  if (numberOfWaypointsAhead > 0) {
    return 'Your driver is currently making another stop';
  }

  return null;
};

export default class OrderCardHeader extends PureComponent {
  static propTypes = {
    eta: PropTypes.number.isRequired,
    venueName: PropTypes.string,
    onToggleOpenCard: PropTypes.func.isRequired,
    isCardOpen: PropTypes.bool.isRequired,
    isMobile: PropTypes.bool,
    type: PropTypes.oneOf([PICKUP, DROPOFF, RETURN]).isRequired,
    jobState: PropTypes.string.isRequired,
    numberOfWaypointsAhead: PropTypes.number.isRequired,
  };

  static defaultProps = {
    isMobile: false,
    venueName: '',
    customizations: {},
  };

  state = {
    time: new Date(),
  };

  componentWillReceiveProps(nextProps) {
    this.setState({ time: addMinutes(new Date(), nextProps.eta) });
    clearTimeout(this.timeout);
  }

  componentWillUnmount() {
    clearTimeout(this.timeout);
  }

  render() {
    const {
      eta,
      venueName,
      onToggleOpenCard,
      isCardOpen,
      isMobile,
      type,
      jobState,
      numberOfWaypointsAhead,
    } = this.props;

    const { time } = this.state;
    const showEta = Boolean(eta) && numberOfWaypointsAhead === 0;

    this.timeout = setTimeout(() => {
      this.setState({ time: addMinutes(new Date(), eta) });
    }, 30000);

    const title = getTitleNode(jobState, numberOfWaypointsAhead);
    const subtitle = getSubtitle(jobState, type, venueName, numberOfWaypointsAhead);

    return (
      <Container onClick={onToggleOpenCard} isMobile={isMobile}>
        <TextContainer>
          {showEta && (
            <Title>
              {TITLE[type]} at {format(time, 'h:mm A')}
              <TitleETA>
                {' '}
                ({eta}
                min)
              </TitleETA>
            </Title>
          )}
          {!showEta && title ? <Title>{title}</Title> : null}
          {!showEta && !title ? <Title>{subtitle}</Title> : null}
          {title && <SubTitle>{subtitle}</SubTitle>}
        </TextContainer>
        <Icon icon="chevron-up" width={20} height={20} isCardOpen={isCardOpen} />
      </Container>
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/order-card/pending/header/OrderCardHeader.js